module.exports = __webpack_public_path__ + "assets/img/6276c09964c27fb916c2faa67f8c6c8c.svg";